import { render } from "./touchspinPostfix.vue?vue&type=template&id=af048514"
import script from "./touchspinPostfix.vue?vue&type=script&lang=js"
export * from "./touchspinPostfix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__